import {getTitlePrefix, PageMenuNode, searchCurPageHeader, generateMenuHTML, menu_page} from "MWL@2026/presentation/capabilities/menu";

import { setHeightOffset } from "../scale"
setHeightOffset(38); // need to update CSS too... (38/2)

function buildPageMenu(_parent: PageMenuNode|null = null) {
    
    const h1 = document.querySelector('h1')!; // osef (hidden)

    const root: PageMenuNode = {
        html    : h1,
        href    : `#${h1?.id}`,
        text    : getTitlePrefix(1, 1) + h1?.textContent!, //TODO: get...
        level   : 1,
        parent  : null,
        children: []
    }

    let curpos = root;

    const titles = document.querySelectorAll<HTMLElement>("frame-section, frame-subsection, frame-subsubsection");

    for(let title of titles) {

        const level = (title.tagName.length - 13)/ 3 + 2; // h4cky
    
        while( level <= curpos.level )
            curpos = curpos.parent!;

        let text = title.getAttribute('short') ?? title.getAttribute("name")!;
        title.id = text;

        const elem: PageMenuNode = {
            html    : title,
            href    : `#${text}`,
            text    : getTitlePrefix(level, curpos.children.length) + text,
            level,
            children: [],
            parent: curpos
        };

        curpos.children.push(elem);
        curpos = elem;
    }

    return root;
}

const main = document.querySelector('main')!;

function updatePageMenu(menu: PageMenuNode) {

    const last = searchCurPageHeader( menu, main.scrollTop)!;
    const html = generateMenuHTML(last ?? menu);

    menu_page.replaceChildren(...html);
}

const menu = buildPageMenu();
updatePageMenu(menu);

main.addEventListener('scroll', () => updatePageMenu(menu) );